module.exports = __webpack_public_path__ + "img/7.9776f654.jpg";